import { Grid, TextField, Button, Autocomplete, MenuItem } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

// Delivery Date From/To is hidden for these statuses.
const DELIVERY_DATE_HIDDEN_TABS = [
  "waitingQueue",
  "inProgress",
  "paused",
  "loaded",
  "unload",
];

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  drivers,
  activeTab,
  orderStatuses = [],
}) => {
  const showDeliveryDate = !DELIVERY_DATE_HIDDEN_TABS.includes(activeTab);
  const showStatusFilter = activeTab === "overview";

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid container spacing={2} rowSpacing={2.25}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Invoice No"
            variant="outlined"
            fullWidth
            value={filterData.invoice_number || ""}
            onChange={handleChangeFilter("invoice_number")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Job No"
            variant="outlined"
            fullWidth
            value={filterData.jobNo}
            onChange={handleChangeFilter("jobNo")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="Customer"
            variant="outlined"
            fullWidth
            value={filterData.customer}
            onChange={handleChangeFilter("customer")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Autocomplete
            disablePortal
            options={drivers}
            getOptionLabel={(option) => option.full_name}
            value={
              filterData.driver_id
                ? drivers.find((d) => d.driver_id === filterData.driver_id)
                : null
            }
            onChange={(_, newValue) => {
              handleChangeFilter("driver_id")({
                target: { value: newValue ? newValue.driver_id : "" },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Driver"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>

        {/* <Grid item xs={12} sm={6} md={4}>
          <DatePicker
            label="Order Date Start"
            value={
              filterData.orderDateStart
                ? dayjs(filterData.orderDateStart)
                : null
            }
            onChange={(newValue) => {
              const formattedDate = newValue
                ? newValue.format("YYYY-MM-DD")
                : "";
              handleChangeFilter("orderDateStart")({
                target: { value: formattedDate },
              });
            }}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                fullWidth: true,
                variant: "outlined",
              },
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <DatePicker
            label="Order Date End"
            value={
              filterData.orderDateEnd ? dayjs(filterData.orderDateEnd) : null
            }
            onChange={(newValue) => {
              const formattedDate = newValue
                ? newValue.format("YYYY-MM-DD")
                : "";
              handleChangeFilter("orderDateEnd")({
                target: { value: formattedDate },
              });
            }}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                fullWidth: true,
                variant: "outlined",
              },
            }}
          />
        </Grid> */}
  <Grid item xs={12} sm={6}>
          <DatePicker
            label="Invoice Date From"
            value={
              filterData.invoiceDateStart
                ? dayjs(filterData.invoiceDateStart)
                : null
            }
            onChange={(newValue) => {
              const formattedDate = newValue
                ? newValue.format("YYYY-MM-DD")
                : "";
              handleChangeFilter("invoiceDateStart")({
                target: { value: formattedDate },
              });
            }}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                fullWidth: true,
                variant: "outlined",
              },
            }}
          />
        </Grid>

        {/* NEW: Invoice Date End Filter */}
        <Grid item xs={12} sm={6}>
          <DatePicker
            label="Invoice Date To"
            value={
              filterData.invoiceDateEnd
                ? dayjs(filterData.invoiceDateEnd)
                : null
            }
            onChange={(newValue) => {
              const formattedDate = newValue
                ? newValue.format("YYYY-MM-DD")
                : "";
              handleChangeFilter("invoiceDateEnd")({
                target: { value: formattedDate },
              });
            }}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                fullWidth: true,
                variant: "outlined",
              },
            }}
          />
        </Grid>
        {showDeliveryDate && (
          <>
            <Grid item xs={12} sm={6}>
              <DatePicker
                label="Delivery Date From"
                value={
                  filterData.deliveryDateStart
                    ? dayjs(filterData.deliveryDateStart)
                    : null
                }
                onChange={(newValue) => {
                  const formattedDate = newValue
                    ? newValue.format("YYYY-MM-DD")
                    : "";
                  handleChangeFilter("deliveryDateStart")({
                    target: { value: formattedDate },
                  });
                }}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    variant: "outlined",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <DatePicker
                label="Delivery Date To"
                value={
                  filterData.deliveryDateEnd
                    ? dayjs(filterData.deliveryDateEnd)
                    : null
                }
                onChange={(newValue) => {
                  const formattedDate = newValue
                    ? newValue.format("YYYY-MM-DD")
                    : "";
                  handleChangeFilter("deliveryDateEnd")({
                    target: { value: formattedDate },
                  });
                }}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    variant: "outlined",
                  },
                }}
              />
            </Grid>
          </>
        )}

        {activeTab === "delivered" && (
          <>
            <Grid item xs={12} sm={6}>
              <DatePicker
                label="Delivered From"
                value={
                  filterData.deliveredDateStart
                    ? dayjs(filterData.deliveredDateStart)
                    : null
                }
                onChange={(newValue) => {
                  const formattedDate = newValue
                    ? newValue.format("YYYY-MM-DD")
                    : "";
                  handleChangeFilter("deliveredDateStart")({
                    target: { value: formattedDate },
                  });
                }}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    variant: "outlined",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <DatePicker
                label="Delivered To"
                value={
                  filterData.deliveredDateEnd
                    ? dayjs(filterData.deliveredDateEnd)
                    : null
                }
                onChange={(newValue) => {
                  const formattedDate = newValue
                    ? newValue.format("YYYY-MM-DD")
                    : "";
                  handleChangeFilter("deliveredDateEnd")({
                    target: { value: formattedDate },
                  });
                }}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    variant: "outlined",
                  },
                }}
              />
            </Grid>
          </>
        )}

        {showStatusFilter && (
          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="Status"
              variant="outlined"
              fullWidth
              value={filterData.status || ""}
              onChange={(event) => handleChangeFilter("status")(event)}
              SelectProps={{
                MenuProps: { disablePortal: true },
              }}
            >
              <MenuItem value="">All</MenuItem>
              {orderStatuses.map((status) => (
                <MenuItem key={status.code} value={status.code}>
                  {status.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="flex-end"
          gap={1.25}
          sx={{ mt: 0.5, pt: 2, borderTop: "1px solid #ECEFF3" }}
        >
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{
              borderColor: "#7152F3",
              color: "#7152F3",
              "&:hover": {
                borderColor: "#5c34fa",
                backgroundColor: "rgba(113, 82, 243, 0.04)",
              },
            }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            onClick={handleFilter}
            sx={{
              backgroundColor: "#7152F3",
              "&:hover": {
                backgroundColor: "#5c34fa",
              },
            }}
          >
            Filter
          </Button>
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
};

export default FilterItems;
